export default "__VITE_ASSET__CcsWvyk9__"